module.exports = __webpack_public_path__ + "static/Logo-c099f41fa75f79367b8664e9c4350db2.png";